import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "send-invite-contact-container meeting-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flow-title" }, "Create Meeting Type"),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Contact Details")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "message-container" }, "Opt keeps you safe by protecting your contact info. By default, contact information is not shared with the other party to this meeting unless you check one or more of the boxes below.", -1 /* HOISTED */)
const _hoisted_5 = { class: "contact-options" }
const _hoisted_6 = { class: "share-number" }
const _hoisted_7 = { class: "checkbox-wrapper" }
const _hoisted_8 = { class: "share-number-text" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Share my phone number: ")
const _hoisted_10 = { class: "bold" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" for this meeting type")
const _hoisted_12 = { class: "share-email" }
const _hoisted_13 = { class: "checkbox-wrapper" }
const _hoisted_14 = { class: "share-email-text" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Share my email: ")
const _hoisted_16 = { class: "bold" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" for this meeting type")
const _hoisted_18 = { class: "contact-note" }
const _hoisted_19 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["VCheckbox"], {
              class: "share-number-box",
              modelValue: $setup.shareNumber,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.shareNumber) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString($setup.currentUser.phone), 1 /* TEXT */),
            _hoisted_11
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode($setup["VCheckbox"], {
              class: "email-box",
              modelValue: $setup.shareEmail,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.shareEmail) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("span", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString($setup.currentUser.email), 1 /* TEXT */),
            _hoisted_17
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode($setup["TextField"], {
          class: "contact-note__note",
          label: "Other Details (optional)",
          modelValue: $setup.message,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.message) = $event))
        }, null, 8 /* PROPS */, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        class: "borderless previous",
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.emit('previous')))
      }, "Back"),
      _createElementVNode("button", {
        class: "primary confirm-details",
        onClick: $setup.proceed
      }, "Finish")
    ])
  ]))
}